// freeTextPromptsData.js

export const FREE_TEXT_PROMPTS_DATA = {
  subtitle: "Define Your Report Objectives",
  prompts: [
    {
      id: "report_purpose",
      question: "What is the purpose of this report?",
      placeholder: "Enter the main purpose and goals of this report...",
      rows: 3,
    },
    {
      id: "assets_operations",
      question: "Which assets or operations are being assessed?",
      placeholder:
        "Describe the assets, operations, or scope being evaluated...",
      rows: 3,
    },
    {
      id: "end_user",
      question: "Who is the end user (investor, regulator, board)?",
      placeholder: "Identify the primary audience and stakeholders...",
      rows: 2,
    },
    {
      id: "decisions_informed",
      question:
        "What decisions will this report inform (e.g., CAPEX, disclosure, insurance)?",
      placeholder: "Specify the key decisions this report will support...",
      rows: 3,
    },
  ],
};

export const FREE_TEXT_ENVIROMENT = {
  subtitle: "Define Your Report Objectives",
  prompts: [
    {
      id: "environmental_concern",
      question:
        "What environmental concern or impact is this report addressing?",
      placeholder:
        "Describe the specific environmental issue or impact in focus...",
      rows: 3,
    },
    {
      id: "ecosystem_components",
      question: "What ecosystem components are being analyzed?",
      placeholder:
        "List or describe the ecosystems, habitats, or natural resources involved...",
      rows: 3,
    },
    {
      id: "target_recipient",
      question:
        "Who is the target recipient (e.g., EPA, Lender, Client, Ministry)?",
      placeholder: "Indicate who will receive and review this report...",
      rows: 2,
    },
    {
      id: "decisions_supported",
      question:
        "What decisions (permitting, mitigation, site selection) will it support?",
      placeholder:
        "Explain the decision-making processes this report will inform...",
      rows: 3,
    },
    {
      id: "others",
      question: "Others",
      placeholder: "Other",
      rows: 4,
    },
  ],
};

export const FREE_TEXT_SOCIAL = {
  subtitle: "Step 3: Report Objective Definition (Short Form)",
  prompts: [
    {
      id: "report_purpose",
      question: "What is the purpose of this report?",
      placeholder: "Describe the goals and intended outcomes of this report...",
      rows: 3,
    },
    {
      id: "covered_population",
      question: "What specific population does it cover?",
      placeholder:
        "Specify the affected or analyzed population or community...",
      rows: 3,
    },
    {
      id: "report_user",
      question: "Who will use this report (Client, Donor, Bank, Ministry)?",
      placeholder: "Indicate the intended user or recipient of this report...",
      rows: 2,
    },
    {
      id: "action_informed",
      question: "What action or decision should this report inform?",
      placeholder:
        "Outline the key decision-making processes this report supports...",
      rows: 3,
    },
  ],
};
